import { Injectable, inject } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable, map } from 'rxjs';
import { ApiResponse } from '@shared-models';
import { API_CONFIG, ApiConfig } from '../api-config';

/** Shape API de un domicilio de customer (GET response / PUT body). */
export interface CustomerAddressDto {
  id?: string;
  countryId: string;
  countryName?: string;
  provinceId: string;
  provinceName?: string;
  localityId: string;
  localityName?: string;
  typeAddressId: string;
  typeAddressName?: string;
  postalCode: string;
  address: string;
  lat?: number | null;
  lng?: number | null;
  primary: boolean;
}

/** Body de PUT /customers/{id}/addresses */
export type CustomerAddressPayload = {
  countryId: string;
  provinceId: string;
  localityId: string;
  typeAddressId: string;
  postalCode: string;
  address: string;
  lat?: number | null;
  lng?: number | null;
  primary: boolean;
};

/**
 * Domicilios del cliente.
 *   GET  /api/customers/{customerId}/addresses
 *   PUT  /api/customers/{customerId}/addresses  (reemplazo total)
 */
@Injectable({ providedIn: 'root' })
export class CustomerAddressService {
  private readonly http = inject(HttpClient);
  private readonly apiConfig = inject<ApiConfig>(API_CONFIG);

  private resource(customerId: string): string {
    return `${this.apiConfig.apiUrl}/customers/${customerId}/addresses`;
  }

  getByCustomer(customerId: string): Observable<CustomerAddressDto[]> {
    return this.http
      .get<ApiResponse<CustomerAddressDto[]>>(this.resource(customerId))
      .pipe(map((res) => (Array.isArray(res.data) ? res.data : [])));
  }

  replaceAll(
    customerId: string,
    addresses: CustomerAddressPayload[],
  ): Observable<{ message: string; items: CustomerAddressDto[] }> {
    return this.http
      .put<ApiResponse<CustomerAddressDto[]>>(
        this.resource(customerId),
        addresses,
      )
      .pipe(
        map((res) => ({
          message: res.message || 'Domicilios actualizados',
          items: Array.isArray(res.data) ? res.data : [],
        })),
      );
  }
}
